module.exports = __webpack_public_path__ + "img/img_2_.c870a2d5.png";